import locales from '../../constants/locales';

export default Object.freeze({
  [locales.enEN]: Object.freeze({
    value: locales.enEN,
    labelLocalId: 'navbar.languagePopover.item.enEN',
    defaultLabel: 'English',
    icon: 'https://flagcdn.com/w20/us.png'
  }),
  [locales.hrHR]: Object.freeze({
    value: locales.hrHR,
    labelLocalId: 'navbar.languagePopover.item.hrHR',
    defaultLabel: 'Croatian',
    icon: 'https://flagcdn.com/w20/hr.png'
  }),
});